export interface KeywordSyncProgress {
  total: number;
  done: number;
  pending: number;
  pct: number;
}

// Deriva o progresso da sincronizacao a partir do total de palavras-chave do
// perfil e de quantas ainda estao sendo pesquisadas (pending). "done" e o que ja
// foi pesquisado; pct e arredondado. Valores negativos/invalidos sao saneados
// para nunca passar de 100% nem ficar abaixo de 0.
export const computeSyncProgress = (
  totalKeywords: number,
  pendingKeywords: number,
): KeywordSyncProgress => {
  const total = Math.max(0, Math.trunc(totalKeywords || 0));
  const pending = Math.min(total, Math.max(0, Math.trunc(pendingKeywords || 0)));
  const done = total - pending;
  const pct = total === 0 ? 0 : Math.round((done / total) * 100);
  return { total, done, pending, pct };
};

// Formato acordado com o time: "40% · 17 de 42 palavras-chave pesquisadas (faltam 25)".
export const formatSyncProgress = (progress: KeywordSyncProgress): string => {
  const { pct, done, total, pending } = progress;
  return `${pct}% · ${done} de ${total} ${
    total === 1 ? "palavra-chave pesquisada" : "palavras-chave pesquisadas"
  } (faltam ${pending})`;
};
